import React from 'react'
import {CssBaseline, Grid} from "@mui/material";
import {useLocation} from "react-router-dom";
import CustomNavbar from "../components/CustomNavbar";
import NotFoundLayout from "../layouts/common/NotFoundLayout";
import RelevanceLayout from "../layouts/detail/RelevanceLayout";
import LeftNavigation from "../components/LeftNavigation";
import RightLogo from "../components/RightLogo";
import EuropeanCitiesTreeSpeciesLayout from "../layouts/detail/EuropeanCitiesTreeSpeciesLayout";
import UrbanClimateLayout from "../layouts/detail/UrbanClimateLayout";
import Footer from "../components/Footer";
import GrowthModelLayout from "../layouts/detail/GrowthModelLayout";
import RecommendationLayout from "../layouts/detail/RecommendationLayout";
import LiteratureLayout from "../layouts/detail/LiteratureLayout";
import ImprintLayout from "../layouts/detail/ImprintLayout";
import EcosystemLayout from "../layouts/detail/EcosystemLayout";
import StructureGrowthLayout from "../layouts/detail/StructureGrowthLayout";
import GlossaryLayout from "../layouts/detail/GlossaryLayout";


const DetailPage = () =>{
    const location = useLocation();

    const createDetailLayout = () =>{
        switch(location.state.type){
            case "growth_model":
                return <GrowthModelLayout/>
            case "relevance":
                return <RelevanceLayout/>
            case "tree_species":
                return <EuropeanCitiesTreeSpeciesLayout/>
            case "urban_climate":
                return <UrbanClimateLayout/>
            case "ecosystem":
                return <EcosystemLayout/>
            case "recommendation":
                return <RecommendationLayout/>
            case "literature":
                return <LiteratureLayout/>
            case "structure":
                return <StructureGrowthLayout/>
            case "imprint":
                return <ImprintLayout/>
            case "glossary":
                return <GlossaryLayout />
            default:
                return <NotFoundLayout/>
        }

    }

    return (
        <React.Fragment>
            <CssBaseline/>
            <CustomNavbar/>
            <Grid container style={{marginTop: 8}} spacing={3}>
                <Grid item xs={2}>
                    <LeftNavigation />
                </Grid>
                <Grid item xs={8}>
                    {
                        createDetailLayout()
                    }
                </Grid>
                <Grid item xs={2}>
                    <RightLogo/>
                </Grid>
            </Grid>
            <Footer/>
        </React.Fragment>
    )


}
export default DetailPage
